import React, { useState, useEffect } from "react";
import { compose } from "recompose";
import { Button, Table } from "reactstrap";
import {
  TableContainer,
  TableDataFetch,
  withTable,
  ViewingRecords,
  Pagination,
  BulkArchiveButton,
  BulkUndeleteButton,
} from "components/common/Tables/index";
import Page from "components/common/Page";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ApiClient } from "services";
import SuperUserStatsCard, { ModalTable, ExportButton, SearchBarWithDate, useSearchStates } from "../CoreComponents";
import { ColouredLink } from "components/HoverCard";
import BackButton from "components/refactoring/BackButton";
import LoadingMsg from "components/common/LoadingMsg";
import moment from "moment";

export const CompanyList = ({
  selected,
  match,
  url = "core/company",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  search,
  refreshToken,
  refreshData,
  readOnly,
  setOffset,
  setLimit,
  setSearch,
  setFilters,
  filters,
}) => {
  const [headers, setHeaders] = useState({})
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showArchived, setShowArchived] = useState(false);

  const {t} = useTranslation()

  const history = useHistory()
  const api_client = ApiClient()

  const handleModalClose = () => {
    setShowModal(false);
  };
  
  function fetch_header(){
    setLoading(true)
    api_client.get('core/organisation-header-count/').then(resp => {
      console.log("Response:", resp)
      setHeaders(resp.data)
      setLoading(false)
    }).catch(err =>{
      console.log("Err:", err)
      setLoading(false)
    })
  }
  function detailsLink(id) {
    history.push(`/core/company-detail/${id}/`);
}

  const toggleArchived = () => {
    setOffset(0);
    setSelected({});
    const next = !showArchived;
    setShowArchived(next);
    setFilters({ ...filters, archived: next ? 'true' : undefined });
  };

  useEffect(() => {
    fetch_header()
  }, [])

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const {
    searchFront,
    startDate,
    endDate,
    expiryStart,
    expiryEnd,
    subscriptionStatus,
    hanStartDate,
    hanEndDate,
    hanExpiryStart,
    hanExpiryEnd,
    handInput,
    handleSubscriptionStatus,
    resetSearchStates,
  } = useSearchStates();

  const handleFilterClick = (params = {}) => {
    handleSubscriptionStatus(params.subscription_status || null);
    setFilters({
      ...filters,
      search: null,
      start_date_after: null,
      start_date_before: null,
      end_date_after: null,
      end_date_before: null,
      subscription_status: null,
      card_filter: null,
      ...params,
    });
  };

  const applyFilters = () => {
    setFilters({
      ...filters,
      search: searchFront,
      start_date_after: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
      start_date_before: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
      end_date_after: expiryStart ? moment(expiryStart).format('YYYY-MM-DD') : null,
      end_date_before: expiryEnd ? moment(expiryEnd).format('YYYY-MM-DD') : null,
      subscription_status: subscriptionStatus,
      card_filter: null,
    });
  };

  const clearFilters = () => {
    resetSearchStates();
    setFilters({
      ...filters,
      search: null,
      start_date_after: null,
      start_date_before: null,
      end_date_after: null,
      end_date_before: null,
      subscription_status: null,
      card_filter: null,
    });
  };

  const datesData = {
    searchFront,
    startDate,
    endDate,
    expiryStart,
    expiryEnd,
    subscriptionStatus,
  };

  const handleData = {
    handInput,
    hanStartDate,
    hanEndDate,
    hanExpiryStart,
    hanExpiryEnd,
    handleSubscriptionStatus,
  };


  return (
        
  <Page title="Company" className="inv-table">
    <BackButton/>
    <div>
      {loading || data.loading ? <LoadingMsg/> : <>
      <SuperUserStatsCard headers={headers} onFilterClick={handleFilterClick} t={t}/>
      <div className="ml-1">
        <ColouredLink onClick={() => setShowModal(true)}>Invoice Details</ColouredLink>
        <ModalTable headers={headers} handleModalClose={handleModalClose} showModal={showModal}/>

        <ColouredLink onClick={toggleArchived} className="float-right">
          <Trans>{showArchived ? "Show Active" : "Show Archived"}</Trans>
        </ColouredLink>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '5px', padding: '2.5px' }}>
        <SearchBarWithDate
          i={datesData}
          h={handleData}
          placeholder="Search by company, tax number or email"
          t={t}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: '5px', padding: '2.5px' }}>
        <ExportButton exportType="company" dropdownOpen={dropdownOpen} toggleDropdown={toggleDropdown} client={api_client} filters={filters}/>
        {showArchived ?
          <BulkUndeleteButton
            selected={selected}
            url={url}
            onUndeleted={refreshData}
            client={api_client}
            readOnly={readOnly}
            entity="company"
          />
          :
          <BulkArchiveButton
            selected={selected}
            url={url}
            onArchived={refreshData}
            client={api_client}
            readOnly={readOnly}
            entity="company"
          />
        }
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '5px' }}>
          <Button color="primary" size="md" onClick={applyFilters}>
            <Trans>Apply Filters</Trans>
          </Button>
          <Button color="secondary" size="md" onClick={clearFilters}>
            <Trans>Clear</Trans>
          </Button>
        </div>
      </div>
      </>}

      {!data.loading && <>
      <TableContainer
        items={data?.results}
        ordering={ordering}
        onOrderingChanged={setOrdering}
        selected={selected}
        onSelectedChanged={setSelected}
      >
       <Table responsive>
        <thead>
          <tr>
            <th select />
            <th className="text-left">
              <Trans>Company</Trans>
            </th>
            <th>
              <Trans>Tax number</Trans>
            </th>
            <th>
              <Trans>Primary Email</Trans>
            </th>
            <th>
              <Trans>Contact number</Trans>
            </th>
            <th>
              <Trans>Organisations</Trans>
            </th>
            <th>
              <Trans>Country</Trans>
            </th>
            <th>
              <Trans>Subscription Type</Trans>
            </th>
            <th>
              <Trans>Registration Date</Trans>
            </th>
            <th>
              <Trans>Expiry Date</Trans>
            </th>
            <th>
              <Trans>Status</Trans>
            </th>
          </tr>
        </thead>
         <tbody>
         {data?.results?.map((i) => (
            <tr key={i.id}>
              <td select />
              <td className="text-left"><ColouredLink onClick={() => detailsLink(i.id)}>{i.name}</ColouredLink></td>
              <td>{i.tax_number}</td>
              <td>{i.email}</td>
              <td>{i.contact_number}</td>
              <td>{i.organisations_count}</td>
              <td>{i.country}</td>
              <td>{i.subscription_type}</td>
              <td>{i.registration_date ? moment(i.registration_date).format('YYYY-MM-DD') : '-'}</td>
              <td>{i.expiry_date ? moment(i.expiry_date).format('YYYY-MM-DD') : '-'}</td>
              <td>{i.subscription_status}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer></>}
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
      filters={filters}
    />

    {!data.loading && <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />}

    <div className="float-right">
      <Pagination
        size="sm"
        count={data.count}
        limit={limit}
        offset={offset}
        onOffsetChanged={setOffset}
        onLimitChanged={setLimit}
      />
    </div>
    </div>
  </Page>
)};

const enhance = compose(withTable({ limit: 25 }));

export default enhance(CompanyList);
